module.exports = __webpack_public_path__ + "static/media/18ECA34.45c608d0.jpg";